export const FEEDBACK_IMAGE_TYPES = ['PNG', 'JPG', 'JPEG', 'WEBP'];

export const FEEDBACK_IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp';

export const MAX_FEEDBACK_IMAGE_ATTACHMENTS = 5;

export const ALLOWED_FEEDBACK_IMAGE_MIME_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
]);
